import { Trans } from '@ui/i18n/trans';
import { Navbar } from '@common/ui/navigation/navbar/navbar';
import { Form } from '@ui/forms/form';
import { useForm } from 'react-hook-form';
import { FormTextField } from '@ui/forms/input-field/text-field/text-field';
import { Button } from '@ui/buttons/button';
import { useRecaptcha } from '../recaptcha/use-recaptcha';
import { StaticPageTitle } from '../seo/static-page-title';
import { Footer } from '@common/ui/footer/footer';
import { Fragment } from 'react';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick';

import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

export function EncryptionPage() {

  useEffect(() => {
    AOS.init({
      duration: 1500
    });
  }, []);

  return (

    <Fragment>
      <div>
        <Navbar
          className="sticky top-0 flex-shrink-0"
          menuPosition="contact-us-page"
        />

        <BusinessBanner />

        <Protection />

        <Cloud />

        <Challenge />

        <CounterUp />

        <LifeTime />

        <Ease />

        <Accessibility />

        <SetUp />

        <Brands />

        <Footer className="container mx-auto flex-shrink-0 px-24" />
      </div>
    </Fragment>

  );
}



function BusinessBanner() {
  return (
    <>
      <section className='business_banner'>
        <div className='landing-container'>
          <div className='row'>
            <div className='col-xl-8 col-lg-7 mb-4'>
              <div className='encryption_img' data-aos="fade-right">
                <img src="images/homepage/encryption_img.png" alt="" />
              </div>
              <div className='baner_contents encryption_con' data-aos="fade-up">
                <h1>Get <span>Onetime</span> for your Business</h1>
                <p>The complete, secure platform to store, sync and collaborate on your business files with your colleagues</p>
              </div>
            </div>
            <div className='col-xl-4 col-lg-5 mb-4'>
              <div className='business_shadow' data-aos="fade-left">
                <div className='nav_btsn'>
                  <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button className="nav-link active" id="home-tab" data-toggle="tab" data-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">Annual</button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className="nav-link" id="profile-tab" data-toggle="tab" data-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">Lifetime</button>
                    </li>

                  </ul>
                  <div className="tab-content" id="myTabContent">
                    <div className="tab-pane  show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                      <div className='wrapper'>
                        <div className='bussiness_pro'>
                          <div className='d-flex justify-content-center mb-3'>
                            <p className='bpr_bg'>Business</p>
                          </div>
                          <div className='row'>
                            <div className='col-6 mb-2'>
                              <div className='subscription sub_content'>
                                <p>Yearly Subscription</p>
                                <div className='usd'>
                                  <h1>7.99</h1>
                                  <p>USD</p>
                                </div>
                              </div>
                            </div>
                            <div className='col-6 mb-2'>
                              <div className='subscription'>
                                <p>Yearly Subscription</p>
                                <div className='usd'>
                                  <h1>7.99</h1>
                                  <p>USD</p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <p className='per_text'>Per user / Month</p>
                          <div className='ty_btn_flx'>
                            <div className='ty_btn'>
                              <button type='button'>Try For Free</button>
                            </div>
                            <div className='pr_btn'>
                              <button type='button'>Get Pricing</button>
                            </div>
                          </div>
                          <div>
                            <div className='tick'>
                              <div>
                                <img src="images/homepage/tick_img.png" alt="" />
                              </div>
                              <p>1024 GB of cloud storage</p>
                            </div>
                            <div className='tick'>
                              <div>
                                <img src="images/homepage/tick_img.png" alt="" />
                              </div>
                              <p>Original-quality video playback</p>
                            </div>
                            <div className='tick'>
                              <div>
                                <img src="images/homepage/tick_img.png" alt="" />
                              </div>
                              <p>Cloud decompression</p>
                            </div>
                            <div className='tick'>
                              <div>
                                <img src="images/homepage/tick_img.png" alt="" />
                              </div>
                              <p>Free of advertising</p>
                            </div>
                            <div className='tick'>
                              <div>
                                <img src="images/homepage/tick_img.png" alt="" />
                              </div>
                              <p>Encrypted space</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="tab-pane" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                      <div className='wrapper'>
                        <div className='bussiness_pro'>
                          <div className='d-flex justify-content-center mb-3'>
                            <p className='bpr_bg'>Business</p>
                          </div>
                          <div className='row'>
                            <div className='col-6 mb-2'>
                              <div className='subscription sub_content'>
                                <p>Yearly Subscription</p>
                                <div className='usd'>
                                  <h1>7.99</h1>
                                  <p>USD</p>
                                </div>
                              </div>
                            </div>
                            <div className='col-6 mb-2'>
                              <div className='subscription'>
                                <p>Yearly Subscription</p>
                                <div className='usd'>
                                  <h1>7.99</h1>
                                  <p>USD</p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <p className='per_text'>Per user / Month</p>
                          <div className='ty_btn_flx'>
                            <div className='ty_btn'>
                              <button type='button'>Try For Free</button>
                            </div>
                            <div className='pr_btn'>
                              <button type='button'>Get Pricing</button>
                            </div>
                          </div>
                          <div>
                            <div className='tick'>
                              <div>
                                <img src="images/homepage/tick_img.png" alt="" />
                              </div>
                              <p>1024 GB of cloud storage</p>
                            </div>
                            <div className='tick'>
                              <div>
                                <img src="images/homepage/tick_img.png" alt="" />
                              </div>
                              <p>Original-quality video playback</p>
                            </div>
                            <div className='tick'>
                              <div>
                                <img src="images/homepage/tick_img.png" alt="" />
                              </div>
                              <p>Cloud decompression</p>
                            </div>
                            <div className='tick'>
                              <div>
                                <img src="images/homepage/tick_img.png" alt="" />
                              </div>
                              <p>Free of advertising</p>
                            </div>
                            <div className='tick'>
                              <div>
                                <img src="images/homepage/tick_img.png" alt="" />
                              </div>
                              <p>Encrypted space</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

function Protection() {
  return (
    <>
      <section className='protection_section'>
        <div className='landing-container'>
          <div className='row'>
            <div className='col-lg-6 mb-4'>
              <div className='protection_img' data-aos="fade-up-right">
                <img src="images/homepage/protuction.png" alt="image" />
              </div>
            </div>
            <div className='col-lg-6 mb-4'>
              <div className='protection_contents' data-aos="fade-up-left">
                <h2>The Importance of File Protection</h2>
                <p>We all have those pieces of information, those very private files, that we don't want to share with anyone. Work related or just personal documents, photos and videos - all is important, and we deserve digital privacy! That's why we created a feature that would make this ultimate data protection possible.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}


function Cloud() {
  return (
    <>
      <section className='protection_section'>
        <div className='landing-container'>
          <div className='row row_reverse'>
            <div className='col-lg-6 mb-4'>
              <div className='protection_contents' data-aos="fade-right">
                <h2>What is pCloud Encryption?</h2>
                <p>We are dedicated to providing users worldwide with unbreakable file security. With pCloud Encryption you can protect your most sensitive information, your private documents, on any device. No one, even pCloud's administrators, will have access to your content. You hold the key to your online privacy.</p>
              </div>
            </div>
            <div className='col-lg-6 mb-4'>
              <div className='protection_img' data-aos="fade-left">
                <img src="images/homepage/could.png" alt="image" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}


function Challenge() {
  return (
    <>
      <section className='challenge_section'>
        <div className='landing-container'>
          <div className='row justify-content-center'>
            <div className='col-lg-8'>
              <div className='challenge_contents'>
                <h2 data-aos="fade-left">The pCloud Encryption Challenge</h2>
                <p data-aos="fade-right">We are confident that we have built client-side encryption software that nobody can hack. To prove this, we challenged hackers from all parts of the world. Participants from top universities, including Berkeley, Boston, MIT and 613 other organizations put our encryption system to the test. None of them succeeded!</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}


function CounterUp() {
  return (
    <>
      <section className='encrpy_counter'>
        <div className='landing-container'>
          <div className="privileges_head">
            <h1 data-aos="fade-up">Trusted by Hundreds of Millions of Users Globally</h1>
            <p data-aos="fade-down">Enhance the value of your product through integration.</p>
          </div>

          <div className='row justify-content-center pt-sm-5 pt-4'>
            <div className='col-lg-4 col-md-4 col-sm-6 mb-4'>
              <div className='counter_contents' data-aos="zoom-in">
                <h1>400 M+</h1>
                <h3>Registered users</h3>
              </div>
            </div>
            <div className='col-lg-4 col-md-4 col-sm-6 mb-4'>
              <div className='counter_contents' data-aos="zoom-in">
                <h1>23 M+</h1>
                <h3>Daily active users</h3>
              </div>
            </div>
            <div className='col-lg-4 col-md-4 col-sm-6 mb-4'>
              <div className='counter_contents' data-aos="zoom-in">
                <h1>231 M+</h1>
                <h3>Countries or regions</h3>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}


function LifeTime() {
  return (
    <>
      {/* Staer-section */}



      <section className='life_time'>
        <div className='landing-container'>
          <div className="privileges_head">
            <h1 data-aos="fade-left">The Building Blocks of pCloud Encryption</h1>
          </div>
          <div className='row pt-sm-5 pt-4'>
            <div className='col-lg-4 col-md-4 mb-4'>
              <div className='family_contents encrip_cloud' data-aos="zoom-in">
                <div className='family_img'>
                  <img src="images/homepage/link_1.png" alt="" />
                </div>
                <h3>pCloud for Family</h3>
                <p>Share your space with up to four family members.</p>
              </div>
            </div>
            <div className='col-lg-4 col-md-4 mb-4'>
              <div className='family_contents encrip_cloud' data-aos="zoom-in">
                <div className='family_img'>
                  <img src="images/homepage/link_2.png" alt="" />
                </div>
                <h3>pCloud Business</h3>
                <p>Organize your team and collaborate on all business projects.</p>
              </div>
            </div>
            <div className='col-lg-4 col-md-4 mb-4'>
              <div className='family_contents encrip_cloud' data-aos="zoom-in">
                <div className='family_img'>
                  <img src="images/homepage/link_3.png" alt="" />
                </div>
                <h3>Link traffic</h3>
                <p>Get additional traffic for your shared links.</p>
              </div>
            </div>
          </div>
          <div className='wants_text'>
            <p data-aos="fade-right">Want to explore pCloud? Go for our monthly plans or  Try for Free</p>
          </div>
        </div>
      </section>

      {/* End section */}
    </>
  )
}


function Ease() {
  return (
    <>
      <section className='protection_section'>
        <div className='landing-container'>
          <div className='row'>
            <div className='col-lg-6 mb-4'>
              <div className='ease_img' data-aos="fade-up-right">
                <img src="images/homepage/ease.png" alt="image" />
              </div>
            </div>
            <div className='col-lg-6 mb-4'>
              <div className='protection_contents' data-aos="fade-up-left">
                <h2>Ease of Use</h2>
                <p>We all have those pieces of information, those very private files, that we don't want to share with anyone. Work related or just personal documents, photos and videos - all is important, and we deserve digital privacy! That's why we created a feature that would make this ultimate data protection possible.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}


function Accessibility() {
  return (
    <>
      <section className='protection_section'>
        <div className='landing-container'>
          <div className='row'>
            <div className='col-lg-6 mb-4'>
              <div className='protection_contents' data-aos="fade-up-right">
                <h2>Accessibility on Any Device</h2>
                <p>We are dedicated to providing users worldwide with unbreakable file security. With pCloud Encryption you can protect your most sensitive information, your private documents, on any device. No one, even pCloud's administrators, will have access to your content. You hold the key to your online privacy.</p>
              </div>
            </div>
            <div className='col-lg-6 mb-4'>
              <div className='ease_img' data-aos="fade-up-left">
                <img src="images/homepage/device.png" alt="image" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}


function SetUp() {
  return (
    <>
      <section className='life_time'>
        <div className='landing-container'>
          <div className="privileges_head">
            <h1 data-aos="fade-right">How to Set Up an Encryption Folder?</h1>
          </div>
          <div className='row pt-sm-5 pt-4'>
            <div className='col-lg-4 col-md-4 mb-4'>
              <div className='family_contents encrip_cloud' data-aos="zoom-in">
                <div className='family_img'>
                  <img src="images/homepage/link_1.png" alt="" />
                </div>
                <h3>pCloud for Family</h3>
                <p>Share your space with up to four family members.</p>
              </div>
            </div>
            <div className='col-lg-4 col-md-4 mb-4'>
              <div className='family_contents encrip_cloud' data-aos="zoom-in">
                <div className='family_img'>
                  <img src="images/homepage/link_2.png" alt="" />
                </div>
                <h3>pCloud Business</h3>
                <p>Organize your team and collaborate on all business projects.</p>
              </div>
            </div>
            <div className='col-lg-4 col-md-4 mb-4'>
              <div className='family_contents encrip_cloud' data-aos="zoom-in">
                <div className='family_img'>
                  <img src="images/homepage/link_3.png" alt="" />
                </div>
                <h3>Link traffic</h3>
                <p>Get additional traffic for your shared links.</p>
              </div>
            </div>
          </div>
          <div className='wants_text'>
            <p data-aos="fade-up-right">Want to explore pCloud? Go for our monthly plans or  Try for Free</p>
          </div>
        </div>
      </section>
    </>
  )
}


const settings = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 500,
  loop: true,
  autoplay: false,
  slidesToShow: 6, // Adjust this based on your layout
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
      },
    },

    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
  ],
};

function Brands() {
  return (
    <>
      <section className='brand_section'>
        <div className='landing-container'>
          <div className='brands_head' data-aos="fade-up-right">
            <h5 className='pb-5'>Featured in:</h5>
          </div>
          <Slider {...settings}>
            <div className='brand_img'>
              <img src="images/homepage/brand_1.png" alt="Brand 1" />
            </div>
            <div className='brand_img'>
              <img src="images/homepage/brand_2.png" alt="Brand 2" />
            </div>
            <div className='brand_img'>
              <img src="images/homepage/brand_3.png" alt="Brand 3" />
            </div>
            <div className='brand_img'>
              <img src="images/homepage/brand_4.png" alt="Brand 4" />
            </div>
            <div className='brand_img'>
              <img src="images/homepage/brand_5.png" alt="Brand 5" />
            </div>
            <div className='brand_img'>
              <img src="images/homepage/brand_6.png" alt="Brand 6" />
            </div>
          </Slider>
        </div>
      </section>
    </>
  )
}
